import styled from "styled-components";
import { Button as AntButton } from "antd";

export const ChangePinContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 24px 16px;

  .ant-form-item-label {
    text-align: center;
    font-size: 16px;
  }
  .ant-input {
    text-align: center;
  }
`;

export const ChangePinTitle = styled.p`
  color: #71207c;
  font-size: 18px;
  text-align: center;
  line-height: 28px;
  margin: 0px;
  padding: 0px;
  padding-bottom: 10px;
`;

export const Button = styled(AntButton)`
  margin-top: 16px;
  width: 170px;
`;